import { Accessor, UpdateParameters } from '@deck.gl/core';
import { Texture } from '@luma.gl/core';
import { positionTextureLineModule, positionTextureLineModuleName, positionTextureProjectedLineModule, positionTextureProjectedLineModuleName } from '../modules/coast-position-texture';
import { HidableLineLayer } from './hidable-line-layer';

/**
 * Animated dynamic sourcePosition to static target position
 */
export class AnimatedLineLayer<TData> extends HidableLineLayer<
    TData,
    {
        getId: Accessor<TData, number>;
        positionTexture: Texture | null;
    }
> {
    getShaders() {
        const shaders = super.getShaders();
        return {
            ...shaders,
            modules: [...shaders.modules, positionTextureLineModule]
        };
    }

    initializeState() {
        super.initializeState();
        const manager = this.getAttributeManager()!;
        manager.remove(['instanceSourcePositions']);
        manager.addInstanced({
            instanceId: {
                size: 1,
                type: 'uint32',
                accessor: 'getId'
            }
        });
    }

    updateState(params: UpdateParameters<this>): void {
        super.updateState(params);
        if (params.changeFlags.propsChanged) {
            this.state.model?.shaderInputs.setProps({
                [positionTextureLineModuleName]: this.props
            });
        }
    }

}

export class AnimatedLineLayerProjected<TData> extends HidableLineLayer<
    TData,
    {
        getId: Accessor<TData, number>;
        positionTexture: Texture | null;
    }
> {
    getShaders() {
        const shaders = super.getShaders();
        return {
            ...shaders,
            modules: [...shaders.modules, positionTextureProjectedLineModule]
        };
    }

    initializeState() {
        super.initializeState();
        const manager = this.getAttributeManager()!;
        manager.remove(['instanceSourcePositions']);
        manager.remove(['instanceTargetPositions']);
        manager.addInstanced({
            instanceId: {
                size: 1,
                type: 'uint32',
                accessor: 'getId'
            }
        });
    }

    updateState(params: UpdateParameters<this>): void {
        super.updateState(params);
        if (params.changeFlags.propsChanged) {
            this.state.model?.shaderInputs.setProps({
                [positionTextureProjectedLineModuleName]: this.props
            });
        }
    }

}

